import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useLocation } from 'react-router-dom';
import { getOpenMarketProductById } from '../../../../api/product/queries/getOpenMarketProductById';
import { IOpenMarketProductDetail } from '../../../../interfaces/OpenMarketProduct.interfaces';

interface IUseGetOpenMarketProductByIdQueryParams {
  productId: string;
}

export const useGetOpenMarketProductByIdQuery = ({ productId }: IUseGetOpenMarketProductByIdQueryParams) => {
  const location = useLocation();

  return useQuery<IOpenMarketProductDetail, AxiosError>(
    ['open_market_product_by_id', productId],
    () => getOpenMarketProductById({ productId }),
    {
      enabled: Boolean(productId),
    },
  );
};
